import { constants, typographyStyles } from "@newsela/angelou";

const neutral400 = constants.colors.ui.neutral[400];

export const textareaStyles = {
  width: "100%",
  height: "85px",
  padding: "8px 12px",
  overflowY: "hidden" as const,
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  resize: "none" as const,
  ...typographyStyles.textMObj,
  "&::placeholder": {
    color: neutral400,
  },
};

export const inputStyles = {
  width: "100%",
  height: "38px",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "0.3em 0",
  ...typographyStyles.textMObj,
  "&::placeholder": {
    color: neutral400,
  },
};

export const paragraphStyles = {
  width: "100%",
  height: "85px",
  padding: "8px 12px",
  overflowY: "hidden" as const,
  margin: 0,
  ...typographyStyles.textMObj,
};

export const characterCountStyles = {
  alignSelf: "flex-end" as const,
  fontSize: "0.8em",
  color: neutral400,
  marginTop: "0.25em",
  marginRight: "0.5em",
};

export const containerStyles = {
  display: "flex" as const,
  flexDirection: "column" as const,
  width: "100%",
  height: "100%",
};
